import React from 'react';
import { cleanXSS } from '../../helpers/string';
import { withRouter } from 'react-router-dom';

export const linkify = (inputText, history) => {
	let replacedText, replacePattern1, replacePattern2;

	//URLs starting with http://, https://, or ftp://
	replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
	replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

	//URLs starting with "www." (without // before it, or it'd re-link the ones done above).
	replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
	replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

	return replacedText;
};

export const Copy = ({ value, extraFormatting, history }) => {
	const clickHandler = e => {
		const targetLink = e.target.closest('a');
		if (!targetLink) return;
		if (!targetLink.target) {
			e.preventDefault();
			history.push(e.target.pathname);
		}
	};

	let parsedText = value ? value.trim().replace(/(^|\s|>)#(\w+)/g, '$1<a href="/search/$2">#$2</a>') : '';
	parsedText = parsedText.replace(/(^|\s|>)@(\w+)/g, '$1<a href="/handle/$2">@$2</a>');
	parsedText = linkify(parsedText, history);
	parsedText = cleanXSS(parsedText);
	if (extraFormatting) parsedText = extraFormatting(parsedText);

	return <span className="copy" onClick={e => clickHandler(e)} dangerouslySetInnerHTML={{ __html: parsedText }} />;
};

export default withRouter(Copy);
